import React from 'react';
import {
    Button
} from "@telosalliance/ui-core";
import GetAppIcon from '@material-ui/icons/GetApp';

function DownloadZipButton() {
    const handleDownload = async () => {
        // The URL to your endpoint
        const url = './api/getbackup';

        try {
            const response = await fetch(url, {
                method: 'GET'
            });

            if (response.ok) {
                // Retrieve the filename from the Content-Disposition header
                const contentDisposition = response.headers.get('Content-Disposition');
                let fileName = 'telos_spotlight_backup.zip'; // Default filename if parsing fails

                if (contentDisposition) {
                    const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
                    if (matches != null && matches[1]) {
                        fileName = matches[1].replace(/['"]/g, ''); // Remove potential quotes
                    }
                }

                // Convert the response to a Blob
                const blob = await response.blob();

                // Create a URL for the Blob
                const downloadUrl = window.URL.createObjectURL(blob);

                // Create an anchor element and simulate click to prompt download
                const a = document.createElement('a');
                a.href = downloadUrl;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();

                // Cleanup
                window.URL.revokeObjectURL(downloadUrl);
                document.body.removeChild(a);
            } else {
                throw new Error('Failed to download file.');
            }
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    };

    return (
        <Button color="blue" style={{ marginTop: "10px", marginBottom: "10px" }} onClick={handleDownload}><GetAppIcon />Download Backup</Button>
    );
}

export default DownloadZipButton;
